import { render, staticRenderFns } from "./employee-form.vue?vue&type=template&id=3fefcea9"
import script from "./employee-form.vue?vue&type=script&lang=js"
export * from "./employee-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports